(() => {
  let busy = false;
  let previousFocus;
  let previousOverflow;
  const root = () => document.querySelector('[data-bnh-cart-root]');
  const dialog = () => root()?.querySelector('[data-bnh-cart-dialog]');
  const apiRoot = () => window.Shopify?.routes?.root || '/';
  const status = message => { const el = root()?.querySelector('[data-bnh-cart-status]'); if (el) el.textContent = message; };
  const announceCart = count => {
    document.querySelectorAll('.icon-button--cart').forEach(link => {
      link.setAttribute('aria-label', root().dataset.cartLabel.replace('[count]', count));
      let badge = link.querySelector('.cart-count-badge');
      if (count > 0 && !badge) { badge = document.createElement('span'); badge.className = 'cart-count-badge'; badge.setAttribute('aria-hidden', 'true'); link.appendChild(badge); }
      if (badge) { badge.textContent = count > 99 ? '99+' : count; badge.hidden = count === 0; }
    });
    document.dispatchEvent(new CustomEvent('binahad:cart-change', { detail: { itemCount: count } }));
  };
  const installContent = html => {
    if (!html) throw new Error('render');
    const incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bnh-cart-content]');
    const state = incoming?.querySelector('[data-bnh-cart-state]');
    if (!state) throw new Error('render');
    root().querySelector('[data-bnh-cart-content]').replaceChildren(...incoming.childNodes);
    announceCart(Number(state.dataset.itemCount));
  };
  const matchesCart = (html, cart) => {
    const incoming = new DOMParser().parseFromString(html || '', 'text/html');
    if (Number(incoming.querySelector('[data-bnh-cart-state]')?.dataset.itemCount) !== cart.item_count) return false;
    const lines = [...incoming.querySelectorAll('.bnh-cart__line')];
    return lines.length === cart.items.length && cart.items.every(item => {
      const line = lines.find(element => element.dataset.lineKey === item.key);
      return Number(line?.querySelector('[data-bnh-cart-quantity]')?.value) === item.quantity;
    });
  };
  const readCart = async () => {
    const response = await fetch(`${apiRoot()}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('cart');
    return response.json();
  };
  const refresh = async (sections, expectedCart) => {
    const id = root().dataset.sectionId;
    if (sections?.[id]) { installContent(sections[id]); return; }
    const url = new URL(root().dataset.cartUrl, location.origin);
    url.searchParams.set('sections', id);
    url.searchParams.set('_bnh_refresh', Date.now());
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error('render');
    const result = await response.json();
    if (expectedCart && !matchesCart(result[id], expectedCart)) {
      url.searchParams.set('_bnh_refresh', Date.now());
      const retry = await fetch(url, { cache: 'no-store' });
      if (!retry.ok) throw new Error('render');
      const latest = await retry.json();
      if (!matchesCart(latest[id], expectedCart)) throw new Error('render');
      installContent(latest[id]);
      return;
    }
    installContent(result[id]);
  };
  const open = focusTarget => {
    const el = dialog();
    if (!el || el.open) return;
    previousFocus = focusTarget || document.activeElement;
    previousOverflow = document.body.style.overflow;
    document.querySelector('.bnh-promo[open]')?.close();
    document.querySelectorAll('.mobile-drawer.is-open').forEach(menu => { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); });
    document.body.classList.remove('menu-open');
    el.showModal();
    document.body.style.overflow = 'hidden';
    el.querySelector('[data-bnh-cart-close]')?.focus({ preventScroll: true });
  };
  const close = () => dialog()?.close();
  const setBusy = value => { busy = value; root()?.querySelector('[data-bnh-cart-content]')?.setAttribute('aria-busy', String(value)); };
  const fallback = () => { location.assign(root().dataset.cartUrl); };
  const errorFor = (form, message) => {
    let error = form.querySelector('.bnh-product-error');
    if (!error) { error = document.createElement('p'); error.className = 'bnh-product-error'; error.setAttribute('role', 'alert'); form.appendChild(error); }
    error.textContent = message;
  };
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !root() || !dialog()?.showModal) return;
    if (!form.matches('[data-product-form], form[action*="/cart/add"]')) return;
    if (event.defaultPrevented) return;
    event.preventDefault();
    if (busy) return;
    const data = new FormData(form);
    if (!data.get('id')) return;
    const submitter = event.submitter || form.querySelector('[type="submit"]');
    const wasDisabled = submitter?.disabled;
    const oldLabel = submitter?.innerHTML;
    data.set('sections', root().dataset.sectionId);
    data.set('sections_url', location.pathname);
    errorFor(form, '');
    form.setAttribute('aria-busy', 'true');
    if (submitter) { submitter.disabled = true; submitter.setAttribute('aria-busy', 'true'); }
    setBusy(true);
    let added = false;
    try {
      const response = await fetch(`${apiRoot()}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || root().dataset.error);
      added = true;
      await refresh(result.sections);
      open(submitter);
      status(root().dataset.added);
    } catch (error) {
      if (added) fallback();
      else {
        const message = error.message || root().dataset.error;
        errorFor(form, message);
        try {
          const actualCart = await readCart();
          await refresh(undefined, actualCart);
          if (actualCart.item_count > 0) open(submitter);
          status(message);
        } catch { fallback(); }
      }
    } finally {
      setBusy(false);
      form.removeAttribute('aria-busy');
      if (submitter?.isConnected) { submitter.disabled = wasDisabled; submitter.removeAttribute('aria-busy'); if (oldLabel) submitter.innerHTML = oldLabel; }
      if (form.closest('[data-product-root]')) form.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  const change = async (key, quantity, focusKey) => {
    if (busy) return;
    setBusy(true);
    status('');
    let changed = false;
    try {
      const response = await fetch(`${apiRoot()}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: [root().dataset.sectionId], sections_url: location.pathname }) });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || root().dataset.error);
      changed = true;
      await refresh(result.sections);
      const line = [...root().querySelectorAll('[data-line-key]')].find(el => el.matches('article') && el.dataset.lineKey === key);
      (line?.querySelector(focusKey) || dialog().querySelector('[data-bnh-cart-close]'))?.focus({ preventScroll: true });
    } catch (error) {
      if (changed) fallback();
      else { status(error.message || root().dataset.error); try { const actualCart = await readCart(); await refresh(undefined, actualCart); } catch { fallback(); } }
    } finally { setBusy(false); }
  };
  document.addEventListener('click', async event => {
    const target = event.target.closest?.('a, button');
    if (!target || !root()) return;
    if (target.matches('[data-bnh-cart-close]')) { close(); return; }
    if (target.matches('.icon-button--cart') && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      if (busy) return;
      setBusy(true);
      try { await refresh(); open(target); status(''); } catch { fallback(); } finally { setBusy(false); }
      return;
    }
    const line = target.closest('[data-line-key]');
    if (!line) return;
    if (target.matches('[data-bnh-cart-remove]')) change(line.dataset.lineKey, 0, '[data-bnh-cart-quantity]');
    if (target.matches('[data-bnh-cart-step]')) {
      const input = line.querySelector('[data-bnh-cart-quantity]');
      const quantity = Math.max(1, (Number(input.value) || 1) + Number(target.dataset.bnhCartStep));
      if (quantity !== Number(input.value)) change(line.dataset.lineKey, quantity, `[data-bnh-cart-step="${target.dataset.bnhCartStep}"]`);
    }
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches?.('[data-bnh-cart-quantity]')) return;
    const quantity = Math.max(1, parseInt(input.value, 10) || 1);
    change(input.dataset.lineKey, quantity, '[data-bnh-cart-quantity]');
  });
  const bindDialog = () => {
    const el = dialog();
    if (!el || el.dataset.bound) return;
    el.dataset.bound = 'true';
    el.addEventListener('close', () => { document.body.style.overflow = previousOverflow || ''; (previousFocus?.isConnected ? previousFocus : document.querySelector('.icon-button--cart'))?.focus({ preventScroll: true }); });
    el.addEventListener('click', event => { if (event.target !== el) return; const box = el.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(); });
  };
  bindDialog();
  document.addEventListener('shopify:section:load', bindDialog);
})();
